import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-notfoundpage',
  templateUrl: './notfoundpage.component.html',
  styleUrls: ['./notfoundpage.component.scss']
})
export class NotfoundpageComponent implements OnInit {

  fromUrl: string = '/'; 
  
  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['fromUrl']) {
        this.fromUrl = params['fromUrl'];
        console.log("Url Obtenida: ", this.fromUrl);
        console.log("Redirigido por inactividad en:", new Date().toLocaleString());
      }
    });
  }

  fnReloadPage() {
    window.location.href = this.fromUrl;
  }
}
